import { render, staticRenderFns } from "./InstagramMessages.vue?vue&type=template&id=19147c2a&"
import script from "./InstagramMessages.vue?vue&type=script&lang=js&"
export * from "./InstagramMessages.vue?vue&type=script&lang=js&"
import style0 from "./InstagramMessages.vue?vue&type=style&index=0&id=19147c2a&prod&lang=sass&"
import style1 from "./InstagramMessages.vue?vue&type=style&index=1&id=19147c2a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports